import styled from 'styled-components'

export const StyleBody = styled.div`
  background: #f3f3f3;
  height: 100%;
`

export const StyleFormHead = styled.div`
  text-align: center;
  margin-bottom: 30px;
  img {
    width: 180px;
    padding-bottom: 10px;
  }
  p {
    font-size: 18px;
    margin-bottom: 10px;
  }
  div {
    font-size: 14px;
    color: gray;
  }
`
